<template>
  <div class="page container">
    
    <Menu></Menu>
    <h1 class="is-size-4">
      <small class="has-text-weight-bold">Configurações</small>
    </h1>
  </div>  
</template>

<script>
  import Menu from './_menu';

  export default {
    components: {
      Menu
    }
  };
</script>

<style>

</style>